import { observer } from 'mobx-react-lite';

import { Sprechtag } from '@codefluegel/wowis-rest-typescript-client';
import { Box, BoxProps, Grid, styled, Typography } from '@mui/material';
import { autorun } from 'mobx';
import { useEffect, useState } from 'react';
import { useObjectsApi } from '../ApiClient';
import GridContainer from '../components/container/GridContainer';
import useMedia from '../hooks/useMedia';
import { useStore } from '../store/context';

const Container = styled(Box)<BoxProps>(({ theme }) => ({
  height: '100%',
  backgroundColor: theme.palette.background.paper,
}));

const ConsultationDaysPage = observer((): JSX.Element => {
  const { welcomeStore } = useStore();
  const { currentEstate } = welcomeStore;
  const objectsApi = useObjectsApi();
  const [consultationDays, setConsultationDays] = useState<Sprechtag[]>();
  const isMobile = useMedia('md');

  useEffect(
    () =>
      autorun(() => {
        async function getConsutationDays() {
          if (currentEstate?.objId) {
            const { data } = await objectsApi.getObjektSprechtagDates(
              Number(currentEstate?.objId),
            );
            setConsultationDays(data);
          }
        }
        getConsutationDays();
      }),
    [objectsApi, currentEstate],
  );

  return (
    <GridContainer>
      <Grid container>
        <Grid item xs={12} marginTop={2}>
          <Container alignItems="center">
            {consultationDays && consultationDays.length > 0 ? (
              consultationDays?.map(consultationDay => (
                <Box
                  marginLeft={isMobile ? 2 : 8}
                  marginRight={isMobile ? 2 : 8}
                  paddingTop={2}
                  marginBottom={4}
                  key={consultationDay.zusatzInformation}
                  paddingBottom={4}
                  sx={{
                    backgroundColor: 'secondary.light',
                    borderRadius: '20px',
                  }}
                >
                  <Typography
                    textAlign="center"
                    style={{
                      whiteSpace: 'pre-line',
                      fontWeight: 'bold',
                      fontSize: isMobile ? 32 : 48,
                    }}
                  >
                    {consultationDay.header}
                  </Typography>
                  <br />
                  <Typography
                    textAlign="center"
                    style={{
                      whiteSpace: 'pre-line',
                      fontWeight: 'bold',
                      fontSize: isMobile ? 36 : 52,
                    }}
                  >
                    {consultationDay.gemeinde}
                  </Typography>
                  <Typography
                    textAlign="center"
                    variant="h4"
                    style={{ whiteSpace: 'pre-line' }}
                  >
                    {consultationDay.art}
                  </Typography>
                  <br />
                  <br />
                  <Typography
                    textAlign="center"
                    style={{
                      whiteSpace: 'pre-line',
                      fontWeight: 'bold',
                      fontSize: isMobile ? 22 : 28,
                    }}
                  >
                    {consultationDay.veranstaltungsort}
                  </Typography>
                  <Typography
                    textAlign="center"
                    style={{
                      whiteSpace: 'pre-line',
                      fontSize: isMobile ? 22 : 28,
                    }}
                  >
                    {consultationDay.ortsteil}
                  </Typography>
                  <br />
                  <Typography
                    textAlign="center"
                    style={{
                      whiteSpace: 'pre-line',
                      fontWeight: 'bold',
                      fontSize: isMobile ? 22 : 28,
                    }}
                  >
                    {consultationDay.termine}
                  </Typography>
                  <br />
                  <Typography
                    textAlign="center"
                    style={{
                      whiteSpace: 'pre-line',
                      fontSize: isMobile ? 18 : 22,
                    }}
                  >
                    {consultationDay.zusatzInformation}
                  </Typography>
                </Box>
              ))
            ) : (
              <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                <Typography variant="h4">
                  Aktuell keine Sprechtage - Bitte kommen Sie später vorbei
                </Typography>
              </Box>
            )}
          </Container>
        </Grid>
      </Grid>
    </GridContainer>
  );
});

export default ConsultationDaysPage;
